import type { IconDef } from './kit';
import { animals } from './sets/animals';
import { food } from './sets/food';
import { home } from './sets/home';
import { people } from './sets/people';
import { play } from './sets/play';
import { stuff } from './sets/stuff';
import { symbols } from './sets/symbols';
import { vehicles } from './sets/vehicles';

/** Every icon by category, for the preview sheet and the duplicate check. */
export const ICON_SETS = { food, animals, vehicles, people, home, stuff, play, symbols } as const;

/** Every icon in the game. Use them in text as `:id:` tokens. */
export const ICONS = {
  ...food,
  ...animals,
  ...vehicles,
  ...people,
  ...home,
  ...stuff,
  ...play,
  ...symbols,
} satisfies Record<string, IconDef>;

export type IconId = keyof typeof ICONS;
/** An icon written inline: `:beer:`. */
export type IconToken = `:${IconId}:`;

export const tok = (id: IconId): IconToken => `:${id}:`;
